import { Component } from '@angular/core'
import { MatSidenavModule } from '@angular/material/sidenav'
import { MatToolbarModule } from '@angular/material/toolbar'
import { Router, RouterOutlet } from '@angular/router'
import { ToolbarComponent } from '../../components/toolbar/toolbar.component'
import { SideMenuComponent } from '../../components/side-menu/side-menu.component'
import { CommonModule } from '@angular/common'
import { AuthService } from '../../services/login/auth.service'
import { FooterComponent } from '../footer/footer.component'
import { JwtHelperService } from '@auth0/angular-jwt'
import { Profile, TokenSession } from '../../models/users.interface'
import { LocalStorageService } from '../../services/local-storage/local-storage.service'
import { catchError, of, switchMap } from 'rxjs'
import { ProfileService } from '../../services/profile/profile.service'
import { LoadingGlobalComponent } from '../../components/loading-global/loading-global.component'
import { LayoutService } from '../../services/layout/layout.service'
import { DecodedToken } from '../../models/auth.interface'
import { jwtDecode } from 'jwt-decode'

@Component({
    selector: 'app-body',
    standalone: true,
    imports: [
        CommonModule,
        RouterOutlet,
        MatToolbarModule,
        MatSidenavModule,
        ToolbarComponent,
        SideMenuComponent,
        FooterComponent,
        LoadingGlobalComponent,
    ],
    templateUrl: './body.component.html',
    styleUrl: './body.component.css',
})
export class BodyComponent {
    // session: string | null = null;
    opened = true
    userSession: TokenSession | null = null

    constructor(
        private authService: AuthService,
        private jwtHelper: JwtHelperService,
        private localStorage: LocalStorageService,
        private router: Router,
        private perfilService: ProfileService,
        private layoutService: LayoutService
    ) {
        // this.session = this.authService.getAccessToken();
    }

    ngOnInit(): void {
        const user = this.perfilService.getUserProfile()
        this.authService.token$.subscribe((token) => (this.userSession = token))
        this.localStorage.initStorage()

        //revisa si la sesion guardada esta expirada para refrescar el token
        const token = localStorage.getItem('token')
        if (token && this.jwtHelper.isTokenExpired()) {
            const parseToken = JSON.parse(token) as TokenSession
            this.authService
                .refreshToken(parseToken.refresh)
                .pipe(
                    catchError((error) => {
                        this.rejectUser()
                        return []
                    }),
                    switchMap((response) => {
                        if (response) {
                            const freshToken: TokenSession = {
                                access: response.access,
                                refresh: parseToken.refresh,
                            }
                            this.authService.setToken(freshToken)
                            localStorage.setItem(
                                'token',
                                JSON.stringify(freshToken)
                            )
                            const decodedToken: DecodedToken = jwtDecode(
                                response.access
                            )
                            return this.perfilService.getOneProfile(
                                String(decodedToken.user_id)
                            )
                        }
                        return []
                    })
                )
                .subscribe({
                    next: (profile) => {
                        this.setProfile(profile)
                        this.layoutService.genMenuLinks(profile)
                    },
                    error: (err) => {
                        this.rejectUser()
                    },
                })
        }
        // si el token aun esta activo trae su info
        if (token && !this.jwtHelper.isTokenExpired()) {
            this.layoutService.genMenuLinks(user)
            const decodedToken: DecodedToken = jwtDecode(token)
            this.perfilService
                .getOneProfile(String(decodedToken.user_id))
                .subscribe({
                    next: (profile) => {
                        this.setProfile(profile)
                    },
                    error: (err) => {
                        this.rejectUser()
                    },
                })
        }
    }

    private rejectUser(): void {
        this.authService.logout()
        localStorage.clear()
        this.router.navigate(['login'])
        window.location.reload()
    }

    setProfile(profile: Profile) {
        this.perfilService.setUserProfile(profile)
        // this.router.navigate(['inicio'])
    }
}
